export const mockData = {
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Instructor Training', path: '/instructor-training' },
    { name: 'Franchise', path: '/franchise' },
    { name: 'Blog', path: '/blog' },
    { name: '0% Finance', path: '/finance', highlight: true },
    { name: 'Contact', path: '/contact' }
  ],
  
  hero: {
    title: 'Learn to drive Automatic in Liverpool',
    subtitle: 'Professional automatic driving instruction from certified experts. Get your license with Top Driver Driving School - Liverpool\'s trusted automatic driving school.',
    cta: 'Book Your Lesson',
    ctaSecondary: 'View Pricing'
  },
  
  whyChooseUs: [
    {
      title: 'Certified Instructors',
      description: 'Learn from experienced, state-certified automatic driving instructors with proven track records.'
    },
    {
      title: 'Modern Automatic Vehicles',
      description: 'Practice in well-maintained, safe automatic vehicles equipped with dual controls for your safety.'
    },
    {
      title: 'High Pass Rate',
      description: '60% of our students pass their automatic driving test on the first attempt.'
    }
  ],
  
  intensiveCrashCourse: {
    name: 'Intensive Automatic Crash Course',
    price: '£1,649',
    originalPrice: '£1,849',
    duration: '1-2 Week Program',
    description: 'Fast-track your automatic driving skills with our intensive program. Perfect for those who need to get road-ready quickly!',
    features: [
      '30 hours of intensive automatic behind-the-wheel training',
      'State-certified automatic driving instructor',
      'Modern automatic vehicles',
      'Pick-up and drop-off service across Liverpool',
      'Progress tracking',
      'Practical driving test preparation',
      'DMV scheduling assistance',
      'Highway driving practice',
      'Parking mastery (no clutch control needed!)',
      'Emergency maneuvers training'
    ],
    bonusFeature: '🎁 FREE practical test fee*',
    highlight: 'Limited Time Offer - Save £200!'
  },

  pricingPlans: [
    {
      name: 'Standard Session',
      price: '£67',
      duration: '90 Minutes',
      packageId: 'standard_session',
      paymentEnabled: true,
      features: [
        '90 minutes of driving instruction',
        'One-on-one personalised tuition',
        'Flexible scheduling to suit you',
        'Modern automatic vehicle',
        'Pick-up and drop-off available',
        'Perfect for regular practice',
        'Pay as you go - no commitment'
      ],
      popular: false
    },
    {
      name: 'Mock Test',
      price: '£75',
      duration: '1.5 Hour Session',
      packageId: 'mock_test',
      paymentEnabled: true,
      features: [
        '1.5 hour mock test session',
        'Real test route with TomTom Sat Nav (same as examiners use)',
        'Or following road signs - your choice',
        'Some or all manoeuvres - whatever you require',
        'Realistic test conditions',
        'Detailed feedback after the session',
        'Pay by finance with 0% interest available'
      ],
      popular: false
    },
    {
      name: 'Complete Package',
      price: '£1,350',
      duration: '30 Automatic Lessons',
      packageId: 'complete_package',
      paymentEnabled: true,
      features: [
        '30 hours of automatic behind-the-wheel training',
        'State-certified automatic instructor',
        'Modern automatic vehicles',
        'Pick-up and drop-off service',
        'Flexible scheduling',
        'Progress tracking',
        'Practical driving test preparation',
        'Pay by finance with 0% interest available'
      ],
      popular: true
    },
    {
      name: 'Intensive Crash Course',
      price: '£1,649',
      duration: '30 Automatic Lessons',
      packageId: 'intensive_crash_course',
      paymentEnabled: true,
      features: [
        '30 hours of automatic behind-the-wheel training',
        'Completed in 1-2 weeks (depends on your availability)',
        'State-certified automatic instructor',
        'Modern automatic vehicles',
        'Pick-up and drop-off service',
        'Flexible scheduling',
        'Progress tracking',
        'Practical driving test preparation',
        'Highway driving practice',
        'Parking mastery',
        'Pay by finance with 0% interest available'
      ],
      bonusFeature: '🎁 FREE practical test fee*',
      popular: false
    }
  ],
  
  testimonials: [
    {
      name: 'Sarah',
      text: 'Top Driver gave me the confidence I needed to pass my test on the first try. The instructors are patient and knowledgeable!',
      rating: 5,
      location: 'Liverpool'
    },
    {
      name: 'Michael',
      text: 'Excellent experience! The flexible scheduling made it easy to fit lessons into my busy work schedule.',
      rating: 5,
      location: 'Anfield, Liverpool'
    },
    {
      name: 'Emily',
      text: 'I was nervous about driving, but my instructor made me feel comfortable from day one. Highly recommend!',
      rating: 5,
      location: 'Norris Green, Liverpool'
    }
  ],
  
  services: [
    {
      title: 'Teen Driver Education (Automatic)',
      description: 'Comprehensive automatic driver education program for teens ages 15-17. Learn in modern automatic vehicles with patient instructors.',
      features: ['30 hours classroom instruction', '6 hours automatic behind-the-wheel', 'State-approved curriculum', 'Parent involvement sessions']
    },
    {
      title: 'Adult Automatic Driving Lessons',
      description: 'Personalized automatic instruction for adult learners. Whether you\'re a first-time driver or switching from manual, we make learning automatic easy.',
      features: ['Customized lesson plans', 'Flexible scheduling', 'Patient instruction', 'Highway driving included']
    },
    {
      title: 'Road Test Preparation (Automatic)',
      description: 'Intensive preparation for your automatic driving test. Practice in the same automatic vehicle you\'ll use for the test.',
      features: ['Mock road tests', 'Common mistake review', 'DMV route practice', 'Last-minute tips']
    },
    {
      title: 'Defensive Driving (Automatic)',
      description: 'Advanced automatic driving techniques to keep you safe. Learn to anticipate and avoid dangerous situations in automatic vehicles.',
      features: ['Hazard recognition', 'Emergency maneuvers', 'Weather driving', 'Insurance discounts available']
    }
  ],
  
  instructorTraining: {
    name: 'Become a Driving Instructor',
    price: '£1,499',
    tagline: '3X More In-Car Training Than Competitors',
    description: 'Comprehensive ADI training program with 30 hours of in-car sessions. Unlike big franchise schools offering only 10 hours in-car + 20 hours classroom, we focus on real-world teaching experience.',
    compareFeatures: {
      us: '30 hours in-car training',
      competitors: '10 hours in-car + 20 hours classroom'
    },
    includes: [
      'ADI Part 2 Training (Driving Ability)',
      'ADI Part 3 Training (Instructional Ability)',
      '30 hours of in-car practical training',
      'Mock test sessions for both parts',
      'Study materials and resources included',
      'One-to-one personalized coaching',
      'Flexible training schedule',
      'Support until you pass',
      'Real teaching experience with learner drivers',
      'Liverpool test centre familiarization',
      'Pay by finance with 0% interest available'
    ],
    benefits: [
      {
        title: 'Real In-Car Experience',
        description: '30 hours of actual in-car training - 3X more than big franchise schools. Learn by doing, not just sitting in a classroom.'
      },
      {
        title: 'Flexible Training',
        description: 'Train at your own pace with flexible scheduling. Perfect for career changers and those with existing commitments.'
      },
      {
        title: 'Expert Mentorship',
        description: 'Learn from experienced ADI trainers who have trained dozens of successful instructors in Liverpool.'
      },
      {
        title: 'Pass Guarantee Support',
        description: 'We support you until you pass. Additional sessions available if needed at discounted rates.'
      }
    ],
    faqs: [
      {
        question: 'What are the requirements to become an ADI?',
        answer: 'You must be at least 21 years old, have held a full UK or EU driving licence for at least 3 years, and have no more than 6 penalty points.'
      },
      {
        question: 'How long does it take to qualify?',
        answer: 'Most trainees complete within 6-12 months depending on their pace and availability. Our flexible schedule allows you to train around your current commitments.'
      },
      {
        question: 'What is ADI Part 2 and Part 3?',
        answer: 'Part 2 tests your driving ability to a high standard. Part 3 tests your ability to instruct - we focus heavily on Part 3 with 30 hours of in-car teaching practice.'
      },
      {
        question: 'Why do you offer more in-car training?',
        answer: 'Big franchise schools focus on classroom theory (20 hours) to save costs. We believe real teaching happens in the car, so we give you 30 hours of practical in-car experience with real learners.'
      },
      {
        question: 'What happens after I qualify?',
        answer: 'You can work for yourself as a freelance instructor, join our team at Top Driver, or work with other schools. The average ADI in Liverpool earns £40,000-£60,000 gross per year (before expenses).'
      },
      {
        question: 'Do you help with Part 1 (theory)?',
        answer: 'Part 1 is a theory test you can study for independently. We focus on Part 2 and Part 3 which require expert coaching and practical experience.'
      }
    ],
    testimonials: [
      {
        name: 'James Mitchell',
        text: 'The 30 hours in-car training made all the difference. I felt confident teaching real students, not just learning theory in a classroom.',
        qualification: 'Qualified ADI 2023'
      },
      {
        name: 'Sarah Thompson',
        text: 'Best decision I made was choosing Top Driver for my ADI training. The extra in-car hours gave me real teaching experience.',
        qualification: 'Qualified ADI 2024'
      }
    ]
  },
  
  aboutInfo: {
    mission: 'At Top Driver Driving School, our mission is to create safe, confident, and responsible drivers through quality education and personalized instruction across Liverpool and Merseyside.',
    story: 'Top Driver has helped over 105 students in Liverpool earn their driver\'s license. Our team of certified instructors brings experience to every lesson, serving the Liverpool community with pride and dedication.',
    stats: [
      { label: 'Students Trained', value: '105+' },
      { label: 'First Attempt Pass Rate', value: '60%' }
    ]
  },
  
  contact: {
    phone: '+44 78 468 78 466',
    email: 'info@topdriver.co.uk',
    address: '45 Bold Street',
    city: 'Liverpool, L1 4HR',
    hours: 'Mon-Fri: 9:30AM-8PM, Sat & Sun: Closed'
  },
  
  socialMedia: [
    { name: 'Facebook', url: 'https://www.facebook.com/share/17xT8fdr1N/?mibextid=wwXIfr', icon: 'Facebook' },
    { name: 'YouTube', url: 'https://youtube.com/@topdriveruk?si=WBDOPUGoNOvC_JVI', icon: 'Youtube' },
    { name: 'Instagram', url: 'https://www.instagram.com/topdriver_uk?igsh=bXI0ZDc3d21rYThr&utm_source=qr', icon: 'Instagram' },
    { name: 'TikTok', url: 'https://www.tiktok.com/@topdrivergb?_r=1&_t=ZN-93GnMY7ng3C', icon: 'Video' }
  ]
};